import React from "react";
import ColorPicker from "../ColorPicker";
import classnames from "classnames";
import { parseManifestEntityUUIDFromName } from "utils/manifest";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import HoverIconButton from "components/HoverIconButton";

const BACKGROUND_COLOR = "backgroundColor";
const COLOR = "color";
const STYLE_KEY = {
  BACKGROUND_COLOR,
  COLOR
};

const PICKER_CONFIG = [
  {
    label: "Colors",
    pickers: [
      {
        label: "Background",
        name: STYLE_KEY.BACKGROUND_COLOR
      },
      {
        label: "Text",
        name: STYLE_KEY.COLOR
      }
    ]
  }
];

const FieldGroupUI = ({ name }) => {
  const entityUUID = parseManifestEntityUUIDFromName(name);
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const fieldUuid = get(values, `${name}.uuid`);
  const fieldUiPath = `${STATE_KEYS.MANIFEST.CONTENT}.${entityUUID}.ui.${fieldUuid}`;
  const rootTouched = Boolean(get(touched, fieldUiPath));

  const pickerNodes = PICKER_CONFIG.map(({ label, pickers }, groupIx) => {
    const isLast = PICKER_CONFIG.length - 1 === groupIx;
    return (
      <div
        key={groupIx}
        className={classnames("w-100", {
          "bb hairline-1 mb3": !isLast
        })}
      >
        <div className={classnames("f6 mb2 dib fw6")}>{label}</div>
        {pickers.map((colorConfig, colorConfigIx) => {
          const pickerName = getFieldPath(fieldUiPath, colorConfig.name);

          return (
            <div key={colorConfigIx} key={colorConfigIx} className="w-100 mb3">
              <ColorPicker
                customClasses={{
                  container:
                    "flex flex-row justify-between items-center items-stretch relative w-100",
                  label: "f6 self-start"
                }}
                name={pickerName}
                label={colorConfig.label}
              />
            </div>
          );
        })}
      </div>
    );
  });

  return (
    <div className="w-100 flex flex-column">
      <div className="flex items-end w-100 justify-end">
        <HoverIconButton
          type="clearFormatting"
          tooltip="Clear"
          onClick={() => {
            setFieldValue(fieldUiPath, {});
            if (!rootTouched) {
              setFieldTouched(fieldUiPath, true);
            }
          }}
        />
      </div>
      {pickerNodes}
    </div>
  );
};

export default FieldGroupUI;
